<template>
  <div
    :class="_className"
    v-on="_othersEvent"
  >
    <div :class="_inputClassName">
      <textarea
        ref="curTextarea"
        class="ten-input__input-input"
        v-bind="$attrs"
        :disabled="disabled"
        :value="value"
        v-on="_inputEvents"
        @input="onInput"
        @change="onChange"
        @blur="onBlur"
        @compositionstart="onCompositionstart"
        @compositionend="onCompositionend"
      />
      <span
        class="ten-input-textarea__limit"
        v-if="showLimit && maxLength "
      >{{ value.length }}/{{ maxLength }}</span>
    </div>
  </div>
</template>

<script>
import Emitter from '../scripts/mixins/emitter';
import debounce from 'lodash/debounce';

export default {
  name: 'TenInputTextarea',
  components: {},
  mixins: [Emitter],
  props: {
    /**
     * @model
     *
     * value 值
     */
    value: {
      type: [String, Number],
      default: '',
    },
    /**
     * 默认 value 值
     */
    defaultValue: [String, Number],
    disabled: Boolean,
    /**
     * 是否错误状态
     */
    error: Boolean,
    /**
     * 自适应高度
     */
    autosize: Boolean,
    /**
     * 字数限制
     */

    maxLength: Number,
    /**
     * 显示字数限制
     */
    showLimit: Boolean,
  },
  computed: {
    _className() {
      return [
        'ten-input ten-input-textarea',
        {
          'ten-input--status-error': this.error,
          'ten-input--disabled': this.disabled,
        },
      ];
    },
    _inputClassName() {
      return [
        'ten-input__input',
        {
          'ten-input__input--status-error': this.error,
          'ten-input__input--disabled': this.disabled,
        },
      ];
    },
    _othersEvent() {
      const {
        keydown,
        keyup,
        keypress,
        change,
        input,
        focus,
        blur,

        ...others } = this.$listeners;

      return others;
    },
    _inputEvents() {
      const { keydown,
        keyup,
        keypress,
        focus,
      } = this.$listeners;
      const events = { keydown,
        keyup,
        keypress,
        focus,
      };
      Object.keys(events).forEach((e) => {
        if (!events[e]) delete events[e];
      });
      return events;
    },
  },
  watch: {
    value: {
      handler() {
        this.resize();
      },
    },
  },
  created() {
    this.setSizeT = 0;
  },
  mounted() {
    this.resize();
    this.debounceResize = debounce(this.resize, 100);
    window.addEventListener('resize', this.debounceResize);
  },
  beforeDestroy() {
    clearTimeout(this.setSizeT);
    window.removeEventListener('resize', this.debounceResize);
  },
  methods: {
    onCompositionstart() {
      this.isCompositionInput = true;
    },
    onCompositionend(e) {
      this.isCompositionInput = false;
      const { maxLength } = this;
      if (maxLength && e.target.value.length > maxLength) {
        e.target.value = e.target.value.substr(0, maxLength);
      }
      this.$emit('input', e.target.value);
    },
    onInput(e) {
      const { maxLength, isCompositionInput } = this;
      if (!isCompositionInput && maxLength && e.target.value.length > maxLength) {
        e.target.value = e.target.value.substr(0, maxLength);
      }
      this.$emit('input', e.target.value);
    },
    onChange(e) {
      this.$emit('change', e.target.value);
    },
    getInputElement() {
      return this.$refs.curTextarea;
    },
    onBlur(e) {
      this.$emit('blur', e);
      this.dispatch('ten-form-item', 'form.blur', this.value);
    },
    focus() {
      this.$refs.curTextarea && this.$refs.curTextarea.focus();
    },
    blur() {
      this.$refs.curTextarea && this.$refs.curTextarea.blur();
    },
    resize() {
      const textareaElem = this.$refs.curTextarea;
      if (this.autosize && textareaElem) {
        textareaElem.style.height = 'auto';
        textareaElem.style.height = `${textareaElem.scrollHeight}px`;
        clearTimeout(this.setSizeT);
        this.setSizeT = setTimeout(() => {
          textareaElem.style.height = `${textareaElem.scrollHeight}px`;
        }, 10);
      }
    },
  },
};
</script>
